import React from "react";
import { Link, Route, Switch, Redirect } from "react-router-dom";
import getLangData from "../../../utils/getLangData";
import langText from "../../../utils/langText";
import Content from "../../../_psb/layout/Content";
import SubHeader from "../../../_psb/layout/sub-header/SubHeader";

import applicants from "./applicants";

const ApplicantsModeration = (props) => {
  const lang = getLangData().general_words;
  return (
    <>
      <SubHeader title={lang.pending_applicants}>
        <Switch>
          <Route
            exact
            path={["/applicants-moderation/:name/:id"]}
            render={({ match: { params } }) => {
              return (
                <Link
                  to={`/applicants-moderation/${params.name}`}
                  className='btn-label-brand btn btn-bold'
                >
                  {getLangData().general_words.back_to_list}
                </Link>
              );
            }}
          />
        </Switch>
      </SubHeader>
      <Content>
        <Switch>
          <Redirect
            exact
            from='/applicants-moderation'
            to='/applicants-moderation/applicants'
          />

          {/* <Redirect
            exact
            from='/applicants-moderation/applicants/:id'
            to='/applicants-moderation/applicants'
          /> */}

          {/**
           * Applicants
           */}

          <Route
            exact
            path={[
              "/applicants-moderation/applicants",
              "/applicants-moderation/applicants/:id",
            ]}
            component={applicants}
          />
        </Switch>
      </Content>
    </>
  );
};

export default ApplicantsModeration;
